module.exports = __webpack_public_path__ + "static/media/paste.bfbf04a8.svg";